import { z } from "zod";

/** Espelham os enums do Prisma (apps/api/prisma/schema.prisma). Mantenha em sincronia. */
export const ROLES = ["OWNER", "SUPERADMIN"] as const;
export type Role = (typeof ROLES)[number];

export const STATUS_CONTA = ["trialing", "active", "past_due", "suspended", "canceled"] as const;
export type StatusConta = (typeof STATUS_CONTA)[number];

export const TIPOS_NUMERO = ["OFICIAL", "NAO_OFICIAL"] as const;
export type TipoNumero = (typeof TIPOS_NUMERO)[number];

export const STATUS_NUMERO = [
  "DESCONECTADO",
  "CONECTANDO",
  "CONECTADO",
  "ERRO",
  "AGUARDANDO_WEBHOOK",
  "ATIVO",
  "RESTRITO",
  "DESATIVADO",
  "REMOCAO_PENDENTE",
] as const;
export type StatusNumero = (typeof STATUS_NUMERO)[number];

export const TIPOS_ENVIO = [
  "PRIMEIRO_CONTATO",
  "PRIMEIRA_RESPOSTA",
  "CONVERSA",
  "RETOMADA",
  "CONTATO_LEAD",
  "AUTO_RESPOSTA",
  "CAMPANHA",
  "GRUPO",
] as const;
export type TipoEnvio = (typeof TIPOS_ENVIO)[number];

export const ORIGENS_MENSAGEM = [
  "CONTATO",
  "CELULAR",
  "PAINEL",
  "API",
  "AUTO",
  "CAMPANHA",
  "REPASSE",
] as const;
export type OrigemMensagem = (typeof ORIGENS_MENSAGEM)[number];

export const STATUS_MENSAGEM = [
  "ENFILEIRADA",
  "ENVIADA",
  "ENTREGUE",
  "LIDA",
  "FALHOU",
  "RECEBIDA",
] as const;
export type StatusMensagem = (typeof STATUS_MENSAGEM)[number];

export const CATEGORIAS_META = ["MARKETING", "UTILITY", "AUTHENTICATION"] as const;
export type CategoriaMeta = (typeof CATEGORIAS_META)[number];

export const STATUS_CAMPANHA = [
  "RASCUNHO",
  "AGENDADA",
  "EM_ANDAMENTO",
  "PAUSADA",
  "PAUSADA_AUTOMATICAMENTE",
  "CONCLUIDA",
  "CANCELADA",
] as const;
export type StatusCampanha = (typeof STATUS_CAMPANHA)[number];

export const STATUS_LEAD = [
  "NOVO",
  "REPASSADO",
  "EM_CONTATO",
  "RESPONDEU",
  "SEM_RESPOSTA",
  "DESCARTADO",
] as const;
export type StatusLead = (typeof STATUS_LEAD)[number];

/** Nomes dos eventos de saída (webhook e RabbitMQ). */
export const EVENTOS_SAIDA = [
  "mensagem.recebida",
  "mensagem.enviada",
  "mensagem.status",
  "numero.status",
  "numero.qrcode",
  "contato.optout",
  "campanha.status",
  "lead.criado",
  "lead.repassado",
  "lead.status",
  "mensagem.reacao",
  "mensagem.editada",
  "mensagem.apagada",
  "mensagem.voto",
  "contato.digitando",
  "contato.presenca",
  "contato.atualizado",
  "chamada.recebida",
  "chamada.encerrada",
  "numero.banido",
  "historico.sincronizado",
  "grupo.atualizado",
  "grupo.participantes",
  "grupo.entrou",
  "etiqueta.alterada",
  "etiqueta.aplicada",
  "canal.seguido",
  "canal.deixado",
  "evolution.bruto",
] as const;
export type EventoSaidaNome = (typeof EVENTOS_SAIDA)[number];

/**
 * Eventos efêmeros: perdem o sentido em minutos. Não passam pela caixa de entrada e têm
 * reenvio curto (2 tentativas em 5 minutos; o registro some em 24h).
 */
export const EVENTOS_EFEMEROS: readonly EventoSaidaNome[] = ["contato.digitando", "contato.presenca", "historico.sincronizado"];

/**
 * O que "todos os eventos" significa quando o cliente não escolhe (WebSocket sem filtro, botão
 * "Marcar todos"): fica de fora o volume alto que só faz sentido pedido explicitamente.
 */
export const EVENTOS_PADRAO: readonly EventoSaidaNome[] = EVENTOS_SAIDA.filter(
  (e) => e !== "evolution.bruto" && e !== "contato.digitando" && e !== "contato.presenca",
);

export const zRole = z.enum(ROLES);
export const zTipoNumero = z.enum(TIPOS_NUMERO);
export const zTipoEnvio = z.enum(TIPOS_ENVIO);
export const zEventoSaida = z.enum(EVENTOS_SAIDA);
